import React, {useRef, useState} from "react";
import dynamic from "next/dynamic";
import {settings} from "../../constants/carousel-settings";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import Icon from "../baseComponents/gui/icon/Icon";
import classNames from "classnames";
import GamesItem from "./GamesItem";
import styles from "./Games.module.scss";

const Carousel = dynamic(() => import('../baseComponents/gui/carousel/Carousel'), {ssr: false});


const Games = React.forwardRef(
  function Games({bets, className, isFetchpriorityGame = false}, ref) {
    const [carouselStatus, setCarouselStatus] = useState("start");
    const prevElRef = useRef(null);
    const nextElRef = useRef(null);

    return (
      <div className={classNames(styles.games, className, {
        [styles[`games_${carouselStatus}`]]: carouselStatus
      })} ref={ref}>
        <Carousel itemsData={bets}
                  item={item => <GamesItem {...item} isFetchpriorityGame={isFetchpriorityGame}/>}
                  settings={{
                    ...settings.games,
                    navigation: {
                      prevEl: ".gamesNavBtnPrev",
                      nextEl: ".gamesNavBtnNext",
                    },
                    onReachEnd: () => {
                      bets.length > 4 && setCarouselStatus("end")
                    },
                    onReachBeginning: () => {
                      bets.length > 4 && setCarouselStatus("start")
                    },
                    onSlideChange: ({isBeginning, isEnd}) => {
                      if (!isBeginning && !isEnd) {
                        setCarouselStatus("")
                      }
                    }
                  }}
        />
        <div className={styles.games__navigation}>
          <Button className={classNames(
            buttonStyles.button_white,
            buttonStyles.button_icon,
            styles.games__navButton,
            "gamesNavBtnPrev"
          )}
                  ref={prevElRef}
                  aria-label={"назад"}
                  title={"назад"}
          >
            <Icon name={"prev"} width={56} height={56}/>
          </Button>
          <Button className={classNames(
            buttonStyles.button_white,
            buttonStyles.button_icon,
            styles.games__navButton,
            "gamesNavBtnNext"
          )}
                  ref={nextElRef}
                  aria-label={"вперед"}
                  title={"вперед"}
          >
            <Icon name={"next"} width={56} height={56}/>
          </Button>
        </div>
      </div>
    );
  });
export default Games;
Games.propTypes = {};

